var attribute = {};
export {
  attribute as __exports
};
//# sourceMappingURL=attribute.js.map
